import { configureStore } from "@reduxjs/toolkit";
import commonReducer from "./common.store";
import authReducer from "./auth.store";
import memberReducer from "./member.store";
import quesAnsReducer from "./quesionAnswer.store";
import petitionReducer from "./petition.store";

export const store = configureStore({
  reducer: {
    common: commonReducer,
    auth: authReducer,
    member: memberReducer,
    quesAns: quesAnsReducer,
    petition: petitionReducer,
  },
  // Disable Redux DevTools in production
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AddDispatch = typeof store.dispatch;
export default store;
